// extracted by mini-css-extract-plugin
export default {"footer":"FloModal_footer__7xNus","header":"FloModal_header__DuE3J","root":"FloModal_root__KXrmE","title":"FloModal_title__jKUvj"};